import * as React from 'react';
import PropTypes from 'prop-types';

import { Avatar, Button } from 'antd';

import Loader from 'shared/components/Loader/Loader';

import s from './UserInfo.pcss';
import EditUserModal from '../../EditUserModal';


export default class UserInfo extends React.Component {
  static propTypes = {
    data: PropTypes.shape().isRequired,
    onPhotoChange: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  state = {
    editMode: false,
    fileLoading: false,
  };

  setFileInputRef = (ref) => {
    this.fileInput = ref;
  };

  setEditMode = editMode => this.setState({ editMode });

  editUser = data =>
    this.props.onEdit(data).then(() => {
      this.setState({ editMode: false });
    });

  handlePhotoChange = () => {
    const file = this.fileInput.files[0];
    if (!file) return;
    this.setState({ fileLoading: true }, () => {
      this.props.onPhotoChange(file).then(() => this.setState({ fileLoading: false }));
    });
  };

  render() {
    const { data } = this.props;
    const { editMode, fileLoading } = this.state;
    return (
      <div className={s.container}>
        <div className={s.photoContainer}>
          {!fileLoading &&
            <div className={s.photo}>
              <Avatar icon="user" className={s.avatar} size={140} src={data.photo} />
            </div>
          }
          {fileLoading &&
            <Loader fullScreen={false} />
          }
          <div className={s.changeLabel}>
            <input
              ref={this.setFileInputRef}
              type="file"
              accept="image/*"
              className={s.fileInput}
              onChange={this.handlePhotoChange}
            />
            <span>Изменить</span>
          </div>
        </div>
        <div className={s.info}>
          <div className={s.fioContainer}>
            <div className={s.name}>{data.lastName}</div>
            <div className={s.name}>{data.firstName}</div>
            <div className={s.name}>{data.patronymicName}</div>
          </div>
          <div className={s.email}>{data.email}</div>
          <div className={s.company}>{data.companyName}</div>
          <div className={s.controls}>
            <Button type="primary" className={s.editBtn} onClick={this.setEditMode}>
              Редактировать
            </Button>
            <EditUserModal
              user={data}
              onEdit={this.editUser}
              visible={editMode}
              onClose={() => this.setEditMode(false)}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Users/UserPage/UserInfo/UserInfo.js